import React from 'react';
import PropTypes from 'prop-types';
import './select.css';

/* Select — the storefront's dropdown (`.br-sort` when it is the sort control).
   A native <select> with an optional leading glyph; see select.css for why it is
   not a custom listbox.

   Options are [value, label] pairs, matching the reference's `sorts` shape, and a
   plain string is accepted as its own label — the app's sort options are strings
   that double as API values, so both forms are live. */
export default function Select({
  options,
  value,
  onChange,
  icon: Icon,
  label,
  className,
  ...rest
}) {
  return (
    <label className={`br-sort${className ? ` ${className}` : ''}`}>
      {Icon && <Icon aria-hidden="true" />}
      <span className="br-sortlbl">{label}</span>
      <select
        className="sd-select"
        aria-label={label}
        value={value}
        onChange={(e) => onChange && onChange(e.target.value, e)}
        {...rest}
      >
        {options.map((o) => {
          const [val, text] = Array.isArray(o) ? o : [o, o];
          return <option value={val} key={val}>{text}</option>;
        })}
      </select>
    </label>
  );
}

Select.propTypes = {
  /** [value, label] pairs, or plain strings that are their own label. */
  options: PropTypes.arrayOf(PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
  ])).isRequired,
  value: PropTypes.string,
  /** Called with the new value, then the event. */
  onChange: PropTypes.func,
  icon: PropTypes.elementType,
  /** Accessible name. The visible glyph is decorative. */
  label: PropTypes.string,
  className: PropTypes.string,
};

Select.defaultProps = { label: 'Sort' };
